@use '@design/design-tokens/typography/typography' as *;
@use '@design/design-tokens/border-radius/border-radius' as *;

.alert {
  margin-bottom: 20px;
}

.container {
  display: flex;
  flex-direction: column;
}

.helperText {
  color: var(--text-soft);
  margin-top: 20px;
  @include typography-v2-body-xs;
}





.label {
  display: inline-flex;
  @include typography-v2-body-sm;
  margin-bottom: 4px;
}
